'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo, useContext } from 'react';

function _define_property(e, n, r) {
    return n in e ? Object.defineProperty(e, n, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[n] = r, e;
}
function _object_spread(e) {
    for(var n = 1; n < arguments.length; n++){
        var r = null != arguments[n] ? arguments[n] : {}, t = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), t.forEach(function(n) {
            _define_property(e, n, r[n]);
        });
    }
    return e;
}
const getComponentConfigProvider = (o)=>{
    let i = createContext({});
    function useInterComponentConfigCtx() {
        return useContext(i);
    }
    i.displayName = `${o}InternalComponentConfig`;
    let InternalComponentConfigProvider = ({ config: n, children: r })=>{
        let o = useInterComponentConfigCtx(), p = useMemo(()=>_object_spread({}, o, n), [
            n,
            o
        ]);
        return jsx(i.Provider, {
            value: p,
            children: r
        });
    };
    return InternalComponentConfigProvider.displayName = 'InternalComponentConfigProvider', [
        InternalComponentConfigProvider,
        useInterComponentConfigCtx,
        i
    ];
};

export { getComponentConfigProvider };
